import { render } from "./AddTabCandidatesModal.vue?vue&type=template&id=a966add8&scoped=true"
import script from "./AddTabCandidatesModal.vue?vue&type=script&lang=js"
export * from "./AddTabCandidatesModal.vue?vue&type=script&lang=js"

import "./AddTabCandidatesModal.vue?vue&type=style&index=0&id=a966add8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a966add8"]])

export default __exports__